export const ADMIN_THEME_STORAGE_KEY = 'rental-news-b-admin-theme';

export function getAdminThemeStorageKey(uid?: string, workspaceId?: string): string {
  return uid && workspaceId ? `${ADMIN_THEME_STORAGE_KEY}:${uid}:${workspaceId}` : `${ADMIN_THEME_STORAGE_KEY}:signed-out`;
}

export function getSystemTheme(): 'light' | 'dark' {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function subscribeSystemTheme(onChange: () => void): () => void {
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}

export function isPublicPromotionRoute(pathname: string): boolean {
  const adminPrefixes = ['/promotions', '/settings', '/404', '/account/password'];
  const isAdminRoute = pathname === '/' ||
    adminPrefixes.some((prefix) => pathname.startsWith(prefix));
  return pathname.startsWith('/view/') || !isAdminRoute;
}

// 인증 전에는 다른 계정의 저장 선호를 읽지 않는다. 인증 후 Provider가 계정별 선호를 적용한다.
export function initializeTheme(): void {
  const theme = isPublicPromotionRoute(window.location.pathname) ? getSystemTheme() : 'light';
  const root = document.documentElement;
  root.classList.remove('light', 'dark');
  root.classList.add(theme);
  root.style.colorScheme = theme;
}
